<template>
  <div>
    <v-card class="mx-auto mt-6" max-width="500">
      <v-card-title class="pa-8 mb-4">
        <v-img src="@/assets/logo.png" height="200" contain></v-img>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" @submit.prevent="updatePassword">
          <v-text-field
            v-model="password"
            :rules="[
              rules.required,
              rules.passwordStrength,
              passwordConfirmationRule()
            ]"
            label="Password"
            type="password"
            required
            prepend-icon="mdi-lock"
          ></v-text-field>
          <v-text-field
            v-model="confirmPassword"
            :rules="[
              rules.required,
              rules.passwordStrength,
              passwordConfirmationRule()
            ]"
            label="Confirm password"
            type="password"
            required
            prepend-icon="mdi-lock"
          ></v-text-field>
          <v-btn class="mt-4" type="submit" color="primary" width="100%"
            >Set Password</v-btn
          >
        </v-form>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title>Password Set Successfully!</v-card-title>
        <v-card-text>
          Your password has been successfuly set. You may now return to the
          login screen and sign in.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text to="/login">Log In</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import object from '@/services/Objects.js'
import Validation from '@/mixins/validation.js'

export default {
  name: 'PasswordReset',
  mixins: [Validation],
  props: ['id'],
  data() {
    return {
      dialog: false,
      valid: true,
      password: '',
      confirmPassword: ''
    }
  },
  computed: {
    passwordConfirmationRule() {
      return () =>
        this.password === this.confirmPassword || 'Password must match'
    }
  },
  watch: {
    password: function() {
      this.$refs.form.validate()
    },
    confirmPassword: function() {
      this.$refs.form.validate()
    }
  },
  methods: {
    updatePassword() {
      if (this.$refs.form.validate()) {
        var model = {
          password: this.password
        }
        ApiService.post(object.User + '/resetpassword/' + this.id, model).then(
          () => {
            this.dialog = true
          }
        )
      }
    }
  }
}
</script>

<style scoped></style>
